// extracted by mini-css-extract-plugin
export var container = "tab-module--container--278Vp";